var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCheckmarkGreyCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#F5F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.854 9.64592C19.9006 9.69236 19.9375 9.74754 19.9627 9.80828C19.9879 9.86903 20.0009 9.93415 20.0009 9.99992C20.0009 10.0657 19.9879 10.1308 19.9627 10.1916C19.9375 10.2523 19.9006 10.3075 19.854 10.3539L12.854 17.3539C12.8076 17.4005 12.7524 17.4374 12.6916 17.4626C12.6309 17.4878 12.5658 17.5008 12.5 17.5008C12.4342 17.5008 12.3691 17.4878 12.3084 17.4626C12.2476 17.4374 12.1924 17.4005 12.146 17.3539L8.646 13.8539C8.55211 13.76 8.49937 13.6327 8.49937 13.4999C8.49937 13.3671 8.55211 13.2398 8.646 13.1459C8.73988 13.052 8.86722 12.9993 9 12.9993C9.13277 12.9993 9.26011 13.052 9.354 13.1459L12.5 16.2929L19.146 9.64592C19.1924 9.59935 19.2476 9.56241 19.3084 9.5372C19.3691 9.512 19.4342 9.49902 19.5 9.49902C19.5658 9.49902 19.6309 9.512 19.6916 9.5372C19.7524 9.56241 19.8076 9.59935 19.854 9.64592Z",
    fill: "#212529"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmarkGreyCircle);
export default __webpack_public_path__ + "static/media/iconCheckmarkGreyCircle.9d4d35165d7a6ec6d897fc19df36b3b9.svg";
export { ForwardRef as ReactComponent };